type SplitsCookie = {
  name: string
  options: {
    path: string
    maxAge: number
    secure: boolean
    sameSite: 'strict'
  }
}

// There's a bug in which we can't set cookies in safari when
// using localhost.
//
// In theory, the secure flag means that the cookie is only accessible
// through a secure channel (HTTP over TLS, or HTTPS):
// https://datatracker.ietf.org/doc/html/rfc6265#section-4.1.2.5. Using
// secure cookies on HTTP localhost, according to the standard, should
// not work.

// However, Chromium-based browsers hasn't implemented this:
// https://issues.chromium.org/issues/40120372, and couldn't find when
// but firefox decided to not do it too. This means that only safari
// fails when using `secure: true` on http://localhost..., as it's strict about
// the RFC-6265 standard.

// Solutions are to (1) only set "secure: false" on safari, or (2)
// only set "secure: true" on https. Because doing (1) would
// require checking the "User-Agent" header, which it's fallible, (2)
// is implemented here.

const shouldUseSecureCookie = () => {
  const location = globalThis.location

  if (!location) {
    // server-render, it doesn't matter what we return here
    return true
  }

  return location.protocol === 'https:'
}

const COOKIE_OPTIONS: SplitsCookie['options'] = {
  path: '/',
  maxAge: 30 * 24 * 60 * 60, // 30 days
  secure: shouldUseSecureCookie(),
  sameSite: 'strict',
}

export const SPLITS_AUTH_TOKEN_COOKIE: SplitsCookie = {
  name: 'splits_auth_token',
  options: COOKIE_OPTIONS,
}

export const SPLITS_ACTIVE_ORG_COOKIE: SplitsCookie = {
  name: 'splits_active_org',
  options: COOKIE_OPTIONS,
}

export const SPLITS_TOAST_MESSAGES_COOKIE: SplitsCookie = {
  name: 'splits_toast_messages',
  options: COOKIE_OPTIONS,
}
